import React from 'react';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';

const PrivacyPolicy = () => (
  <div className="min-h-[60vh] flex items-center justify-center bg-gradient-to-br from-pink-50 to-indigo-50 py-12 px-2">
    <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full p-8 md:p-12">
      <div className="flex items-center justify-center mb-4">
        <ShieldCheckIcon className="h-10 w-10 text-pink-500 mr-2" />
        <h1 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-indigo-500 drop-shadow">
          Privacy Policy
        </h1>
      </div>
      <p className="mb-6 text-lg text-gray-700 text-center">
        We value your privacy. This policy explains how we collect, use, and protect your information:
      </p>
      <section className="mb-6">
        <h2 className="text-xl font-bold text-pink-600 mb-2">What Data We Collect</h2>
        <ul className="list-disc pl-8 space-y-2 text-gray-800">
          <li className="marker:text-pink-500">Personal information (name, email, phone, address) for order processing and support.</li>
          <li className="marker:text-pink-500">Order and payment details.</li>
          <li className="marker:text-pink-500">Usage data (pages visited, device info, etc.).</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-bold text-pink-600 mb-2">How We Use Your Data</h2>
        <ul className="list-disc pl-8 space-y-2 text-gray-800">
          <li className="marker:text-pink-500">To process orders and provide customer support.</li>
          <li className="marker:text-pink-500">To improve our website and services.</li>
          <li className="marker:text-pink-500">To send order updates, offers, and important notifications.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-bold text-pink-600 mb-2">Cookies & Tracking</h2>
        <ul className="list-disc pl-8 space-y-2 text-gray-800">
          <li className="marker:text-pink-500">We use cookies to enhance your browsing experience and analyze site traffic.</li>
          <li className="marker:text-pink-500">You can disable cookies in your browser settings, but some features may not work.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-bold text-pink-600 mb-2">Data Security</h2>
        <ul className="list-disc pl-8 space-y-2 text-gray-800">
          <li className="marker:text-pink-500">We use secure methods to store and transmit your data.</li>
          <li className="marker:text-pink-500">Access to your data is restricted to authorized personnel only.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-bold text-pink-600 mb-2">Your Rights</h2>
        <ul className="list-disc pl-8 space-y-2 text-gray-800">
          <li className="marker:text-pink-500">You can request access, correction, or deletion of your personal data at any time.</li>
          <li className="marker:text-pink-500">Contact us at <a href='mailto:thevastra.store1999@gmail.com' className='text-indigo-600 underline'>thevastra.store1999@gmail.com</a> for privacy requests.</li>
        </ul>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-bold text-pink-600 mb-2">Third-Party Services</h2>
        <ul className="list-disc pl-8 space-y-2 text-gray-800">
          <li className="marker:text-pink-500">We may use third-party services (e.g., payment gateways, analytics) that have their own privacy policies.</li>
        </ul>
      </section>
      <div className="text-right text-sm text-gray-500">Last updated: July 2024</div>
    </div>
  </div>
);

export default PrivacyPolicy; 